// YunEmRate.js
import { memo } from 'react';
import './YunEmRate.css';
import YunIcon from '../YunIcon/YunIcon';
import Slider from '@material-ui/core/Slider';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputBox from '../InputBox/InputBox';

import { formatShowValue } from '../YunEmFineTune/tool';

const YunEmRate = memo(function YunEmRate({ emRate, emRateVal, handleEmRate, ratePreset }) {

    // 速率推杆右边对应插件0值 左边对应插件400值
    const sliderValue = 400 - emRateVal
    const labelValue = formatShowValue(emRateVal, ratePreset);

    const hanleChangeRateVal = (val) => {
        val = 400 - val;
        handleEmRate(val);
    }

    const handleSelectPresetRateValue = (val) => {
        handleEmRate(val);
    }

    if (!emRate) {
        return null
    }
    const MenuItemEle = []
    ratePreset.forEach((ele, index) => {
        MenuItemEle.push(
            <MenuItem className="SelectItem" value={ele.value} key={'rate-item-' + index}>
                {ele.name}
            </MenuItem>
        )
    })

    return (
        <div className="YunCommonLayoutWrapper">
            <div className="YunEmRate YunCommonLayout">
                <div className="Label CursorDefault">
                    强度：
                </div>
                <Slider
                    value={sliderValue}
                    onChange={(e, val) => hanleChangeRateVal(val)}
                    min={0}
                    max={400} />
                <div className="RateSelect">
                    <div className="RateSelectLabel HoverColor MainColor">{labelValue}</div>
                    <YunIcon iconClass="MainColor HoverColor" icon="expand"></YunIcon>
                    <Select value="" onChange={(e, child) => handleSelectPresetRateValue(child.props.value)}>
                        {MenuItemEle}
                        <InputBox val={emRateVal} min={0} max={400} step={1} onChange={handleEmRate} >
                        </InputBox>
                    </Select>
                </div>
            </div>
        </div>
    )
})

export default YunEmRate

